import "./../../levels/common.blocks/search2/search2.react.js";
import _search2_template_websearch from "./../../levels/common.blocks/search2/_template/search2_template_websearch.react.js";

var Search2 = _search2_template_websearch.applyDecls();

import "./../../levels/common.blocks/search2/search2.css";
import "./../../levels/desktop.blocks/search2/_theme/search2_theme_websearch.css";


export default Search2;